import { Link } from "react-router-dom";

export default function ContactTeaser() {
  return (
    <section className="py-16 md:py-24 bg-primary-50 border-y border-primary-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
          Besuchen Sie uns in Leer
        </h2>
        <p className="text-foreground-600 text-base md:text-lg mb-8 max-w-2xl mx-auto">
          Erleben Sie Floristik hautnah in unserer Manufaktur an der Heisfelder Straße 105. Wir freuen uns auf Ihren Besuch.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10 max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-3">
              <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-primary-600"></i>
            </div>
            <p className="font-medium text-foreground-800 text-sm mb-1">Telefon</p>
            <a href="tel:+494914238" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
              0491 4238
            </a>
          </div>
          <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full mx-auto mb-3">
              <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-accent-600"></i>
            </div>
            <p className="font-medium text-foreground-800 text-sm mb-1">Adresse</p>
            <p className="text-foreground-600 text-sm">
              Heisfelder Str. 105<br />26789 Leer
            </p>
          </div>
          <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-full mx-auto mb-3">
              <i className="ri-time-line w-5 h-5 flex items-center justify-center text-secondary-600"></i>
            </div>
            <p className="font-medium text-foreground-800 text-sm mb-1">Sonntag geöffnet</p>
            <p className="text-foreground-600 text-sm">10:30–12:30 Uhr</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Kontakt & Anfahrt
          </Link>
          <Link
            to="/ueber-uns"
            className="inline-flex items-center justify-center px-8 py-3.5 border border-primary-300 text-primary-700 rounded-md text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            Über uns
          </Link>
        </div>
      </div>
    </section>
  );
}